module.exports = __webpack_public_path__ + "static/media/mbtech.d0595c38.svg";